import React from "react";
import TBBLink from "utils/TBBLink";

const Button = ({ children, className, to, style, target, onClick, activeClassName, icon }) => {
  const classes = `group inline-flex justify-center items-center  py-[14px] line-crop font-display tracking-normal text-xl lg:text-3xl text-primary ${ className ? className : ""}`
  return (
    <TBBLink
      className={`${classes}`}
      to={to}
      activeClassName={activeClassName}
      style={style}
      target={target}
      role="button"
      tabIndex="0"
      onClick={onClick}
      onKeyPress={onClick}
      icon={icon}
    >
      {children}
      
      {icon === 'minus' ? 
      <div class="ml-3 md:h-9 h-7 md:w-9 w-7 bg-[#F9DFE8] rounded-full relative flex justify-center items-center duration-300 group-hover:rotate-45">
          <div class="bg-[#091DF3] md:h-[20px] h-[16px] md:w-[3px] w-[3px] absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 duration-300 opacity-0 group-hover:opacity-100"></div>
          <div class="bg-[#091DF3] md:h-[20px] h-[17px] md:w-[3px] w-[3px] absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 rotate-90"></div>
      </div>
      :
      <div class="ml-3 md:h-9 h-7 md:w-9 w-7 bg-[#F9DFE8] rounded-full relative  flex justify-center items-center duration-300 group-hover:rotate-180">
          <div class="bg-[#091DF3] md:h-[20px] h-[16px] md:w-[3px] w-[3px] absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2"></div>
          <div class="bg-[#091DF3] md:h-[20px] h-[17px] md:w-[3px] w-[3px] absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 rotate-90"></div>
      </div>
      }
    </TBBLink>
  );
};

export default Button;
